// extracted by mini-css-extract-plugin
module.exports = {"ErrorDisplay":"ErrorDisplay_ErrorDisplay___sLQR"};